var Coin = "/static/07869614602326ce.png";

export { Coin as default };
//# sourceMappingURL=coin.png.js.map
